// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.how-it-works-wrapper {
    position: relative;
    width: 100vw;
    
  }
  
  .how-it-works-background {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background: var(--blue, #458BEA);
    z-index: -1;
  }
  
  .how-it-works {
    display: flex;
    height: 652px;
    padding: 91px 67.2px 117.6px 67.2px;
    flex-direction: column;
    align-items: center;
    gap: 84px;
    width: 100%;
    max-width: 1512px;
    margin: 0 auto;
  }
  
  .how-it-works .section-title {
    display: flex;
    width: 806.4px;
    flex-direction: column;
    align-items: center;
    gap: 16.8px;
  }
  
  .how-it-works .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 27px;
    align-self: stretch;
  }
  
  .how-it-works .frame {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }
  
  .how-it-works .heading {
    color: var(--white, #FFF);
    text-align: center;
    font-family: Georgia;
    font-size: 50px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 60px */
  }
  
  .how-it-works .heading-2,
  .how-it-works .heading-3 {
    color: var(--white, #FFF);
    text-align: center;
    font-family: Inter;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 130%; /* 31.2px */
  }
  
  .how-it-works .text {
    color: var(--primitive-white);
    text-align: center;
    margin: 0;
    align-self: stretch;
  }
  
  .how-it-works .heading-3 {
    color: var(--semantic-background-color-primary);
  }
  
  .how-it-works .rectangle {
    background-color: var(--primitive-red);
    border-radius: 35px;
    height: 14px;
    width: 221px;
  }
  
  .how-it-works .p {
    color: var(--white, #FFF);
    text-align: center;
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 27px */
    box-sizing: border-box; /* Include padding in the element's total width and height */
    word-wrap: break-word; /* Ensure long words break and wrap */
    overflow-wrap: break-word; /* Ensure long words break and wrap */
    white-space: normal; /* Ensure the text wraps normally */
    margin: 0;
    height: auto; /* Remove fixed height to allow wrapping */
  }
  
  .how-it-works .column {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25.2px;
    flex: 1 0;
  }
  
  .how-it-works .text-wrapper {
    width: 46.2px;
    height: 46.2px;
    text-align: center;
  }
  
  .how-it-works .row {
    display: flex;
    align-items: flex-start;
    gap: 50.4px;
    align-self: stretch;
  }
  
  .how-it-works .div {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 25.2px;
    align-self: stretch;
  }
  
  /* Media query for mobile view */
  @media (max-width: 1224px) {
    .how-it-works {
      padding: 40px 20px;
      gap: 55.04px;
      width: 100%;
      height: auto; /* Adjust height to auto for better layout */
    }
  
    .how-it-works .rectangle {
      display: none;
    }
  
    .how-it-works .column {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 22.933px;
      align-self: stretch;
    }
  
    .how-it-works .section-title,
    .how-it-works .content,
    .how-it-works .frame,
    .how-it-works .row-wrapper,
    .how-it-works .row,
    .how-it-works .div {
      flex-direction: column;
      align-items: center;
      width: 100%;
    }
  
    .how-it-works .p {
      padding: 0 15px;
      word-wrap: break-word;
      overflow-wrap: break-word;
      white-space: normal;
      height: auto; /* Ensure height auto to allow text wrapping */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/HowItWorks/style.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;;EAEd;;EAEA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,YAAY;IACZ,gCAAgC;IAChC,WAAW;EACb;;EAEA;IACE,aAAa;IACb,aAAa;IACb,mCAAmC;IACnC,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;EACV;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;EAC9B;;EAEA;;IAEE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,WAAW;EAChC;;EAEA;IACE,6BAA6B;IAC7B,kBAAkB;IAClB,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,+CAA+C;EACjD;;EAEA;IACE,sCAAsC;IACtC,mBAAmB;IACnB,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,SAAS;IAC5B,sBAAsB,EAAE,4DAA4D;IACpF,qBAAqB,EAAE,qCAAqC;IAC5D,yBAAyB,EAAE,qCAAqC;IAChE,mBAAmB,EAAE,mCAAmC;IACxD,SAAS;IACT,YAAY,EAAE,0CAA0C;EAC1D;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,SAAW;EACb;;EAEA;IACE,aAAa;IACb,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;EACrB;;EAEA,gCAAgC;EAChC;IACE;MACE,kBAAkB;MAClB,YAAY;MACZ,WAAW;MACX,YAAY,EAAE,4CAA4C;IAC5D;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,aAAa;MACb,mBAAmB;IACrB;;IAEA;;;;;;MAME,sBAAsB;MACtB,mBAAmB;MACnB,WAAW;IACb;;IAEA;MACE,eAAe;MACf,qBAAqB;MACrB,yBAAyB;MACzB,mBAAmB;MACnB,YAAY,EAAE,8CAA8C;IAC9D;EACF","sourcesContent":[".how-it-works-wrapper {\n    position: relative;\n    width: 100vw;\n    \n  }\n  \n  .how-it-works-background {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100%;\n    background: var(--blue, #458BEA);\n    z-index: -1;\n  }\n  \n  .how-it-works {\n    display: flex;\n    height: 652px;\n    padding: 91px 67.2px 117.6px 67.2px;\n    flex-direction: column;\n    align-items: center;\n    gap: 84px;\n    width: 100%;\n    max-width: 1512px;\n    margin: 0 auto;\n  }\n  \n  .how-it-works .section-title {\n    display: flex;\n    width: 806.4px;\n    flex-direction: column;\n    align-items: center;\n    gap: 16.8px;\n  }\n  \n  .how-it-works .content {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 27px;\n    align-self: stretch;\n  }\n  \n  .how-it-works .frame {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n  }\n  \n  .how-it-works .heading {\n    color: var(--white, #FFF);\n    text-align: center;\n    font-family: Georgia;\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 120%; /* 60px */\n  }\n  \n  .how-it-works .heading-2,\n  .how-it-works .heading-3 {\n    color: var(--white, #FFF);\n    text-align: center;\n    font-family: Inter;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 130%; /* 31.2px */\n  }\n  \n  .how-it-works .text {\n    color: var(--primitive-white);\n    text-align: center;\n    margin: 0;\n    align-self: stretch;\n  }\n  \n  .how-it-works .heading-3 {\n    color: var(--semantic-background-color-primary);\n  }\n  \n  .how-it-works .rectangle {\n    background-color: var(--primitive-red);\n    border-radius: 35px;\n    height: 14px;\n    width: 221px;\n  }\n  \n  .how-it-works .p {\n    color: var(--white, #FFF);\n    text-align: center;\n    font-family: Inter;\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 27px */\n    box-sizing: border-box; /* Include padding in the element's total width and height */\n    word-wrap: break-word; /* Ensure long words break and wrap */\n    overflow-wrap: break-word; /* Ensure long words break and wrap */\n    white-space: normal; /* Ensure the text wraps normally */\n    margin: 0;\n    height: auto; /* Remove fixed height to allow wrapping */\n  }\n  \n  .how-it-works .column {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 25.2px;\n    flex: 1 0 0;\n  }\n  \n  .how-it-works .text-wrapper {\n    width: 46.2px;\n    height: 46.2px;\n    text-align: center;\n  }\n  \n  .how-it-works .row {\n    display: flex;\n    align-items: flex-start;\n    gap: 50.4px;\n    align-self: stretch;\n  }\n  \n  .how-it-works .div {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 25.2px;\n    align-self: stretch;\n  }\n  \n  /* Media query for mobile view */\n  @media (max-width: 1224px) {\n    .how-it-works {\n      padding: 40px 20px;\n      gap: 55.04px;\n      width: 100%;\n      height: auto; /* Adjust height to auto for better layout */\n    }\n  \n    .how-it-works .rectangle {\n      display: none;\n    }\n  \n    .how-it-works .column {\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      gap: 22.933px;\n      align-self: stretch;\n    }\n  \n    .how-it-works .section-title,\n    .how-it-works .content,\n    .how-it-works .frame,\n    .how-it-works .row-wrapper,\n    .how-it-works .row,\n    .how-it-works .div {\n      flex-direction: column;\n      align-items: center;\n      width: 100%;\n    }\n  \n    .how-it-works .p {\n      padding: 0 15px;\n      word-wrap: break-word;\n      overflow-wrap: break-word;\n      white-space: normal;\n      height: auto; /* Ensure height auto to allow text wrapping */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
